<script>
	import Product from './routes/Product.svelte';
	import Archive from './routes/Archive.svelte';
	import { performSearch } from './lib/api';
	import { appRoute } from './lib/store.js';
	import { style } from './lib/store.js';

	performSearch();

	const routes = {
		'^/$': Archive,
		'^/stock$': Archive,
		'^/stock/(tractorhead|truck|semi-trailer|trailer|various).*': Archive,
		'^/vehicle/used/.*': Product,
	};

	let matchedRoute;
	let path;

	// If we're on the client side
	if (typeof window !== 'undefined') {
		const baseUrl = window.wordpress_object.plugins_url.replace(
			'wp-content/plugins/bts-lagerhofbestand', ''
		);

		path = window.location.pathname
			.replace('wp/lagerhofbestand/', '')
			.replace('lagerhofbestand/', '')
			.replace(window.location.search, '');

		if(appRoute){
			path = path
			.replace(appRoute, '')
			.replace(appRoute + '/', '')
			.replace('wp/' + appRoute + '/', '')
			.replace('wp/' + appRoute, '');
		}

		matchedRoute = Object.keys(routes).find(key => path.match(key) ? path.match(key)[0] : false) || 0;

		// If the path is not a single '/' and the last character is a '/'.
		if (path !== '/' && path[path.length-1] === '/') {
			path = path.slice(0, -1);
		}
	}

	const Route = routes[matchedRoute || routes[0]];
</script>

<div class="banner-wrap {style}">
	<div class="root" style="position: relative;">
		<Route pathElements={path.split('/').filter(e => e)} />
	</div>
</div>

<style type="text/scss" lang="scss" global>
	@import "./scss/variables.scss";
	@import "./scss/mixins.scss";
	@import "./scss/photoswipe.scss";

	.banner-wrap {
		> .root {
			min-height: 100vh;
		}
	}

	:global(.banner-wrap) {
		&.WBS{
			--c-primary   : #468E99;
			--c-sky-blue  : #468E99;
		}
	}

	body {
		max-width: 100vw;
		overflow-x: hidden;
	}

	* {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}

	:global(.show-for-medium) {
		@include small-only {
			display: none;
		} 

	}

	:global(.show-for-small) {
		@include tablet-portrait {
			display: none;
		} 
	}

	:global(.hide-for-large) {
		@include tablet-landscape {
			display: none;
		}
	}

	:global(.show-for-large) {
		display: none;

		@include tablet-landscape {
			display: block;
		}
	}

	:global(.flex) {
		display: flex;
	}
</style>
